import React from 'react'
import moment from 'moment'

import { tenants } from '../../core/controllers/tenants'
import NavLink from '../Routes/NavLink';

export default class TenantsLateOnRentTallyCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            total: 0
        };
    }

    componentDidMount() {
        var self = this;
        tenants.tenantsLateOnRentTally(function(response) {
            self.setState({
                total: response.tally
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const total = this.state.total;
        if (this.props.clickable == true) {
            return (
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <NavLink to={"/tenants?filter=late"}>
                    <div class="info-box">
                        <span class="info-box-icon red-icon-circle"><i class="icon-credit-card-slot"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Late On Rent</span>
                            <br/>
                            <span class="info-box-subtext">Tenants behind on rent</span>
                            <span class="info-box-number red-info-number">{ total }</span>
                        </div>
                    </div>
                    </NavLink>
                </div>
            )
        } else {
            return (
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="info-box">
                        <span class="info-box-icon red-icon-circle"><i class="icon-credit-card-slot"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Late On Rent</span>
                            <br/>
                            <span class="info-box-subtext">Tenants behind on rent</span>
                            <span class="info-box-number red-info-number">{ total }</span>
                        </div>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Tenants/TenantsLateOnRentTallyCard.jsx